import { createSelector } from "reselect";
import * as HotspotTargetType from "utils/HotspotTargetType";

import getPlaybackState from "selectors/chapter/getPlaybackState";
import makeGetChapterEntity from "selectors/chapter/makeGetChapterEntity";
import makeGetHotspotEntity from "selectors/hotspots/makeGetHotspotEntity";
import hotspotClick from "utils/Analytics/actions/hotspotClick";
import NavigationWrapper from "utils/NavigationWrapper";
import handleExternalCallbackHotspotClick from "utils/handleExternalCallbackHotspotClick";
import find from "lodash/find";
import noop from "lodash/noop";

const getStory = (state) => state.story;
const getStorySlug = (state) => state.route.params.storySlug;
const getHotspotId = (state, props) => props.hotspotId;

const findChapterById = (id, story) => {
  const chapterEntity = find(story.chapters, { id });
  return story.entities[chapterEntity.schema][chapterEntity.id];
};

export default function makeGetHotspotClick() {
  const getChapterEntity = makeGetChapterEntity();
  const getHotspotEntity = makeGetHotspotEntity();
  return createSelector(
    [
      getChapterEntity,
      getHotspotEntity,
      getHotspotId,
      getPlaybackState,
      getStory,
      getStorySlug,
    ],
    (
      chapterEntity,
      hotspotEntity,
      hotspotId,
      playbackState,
      story,
      storySlug,
    ) => {
      if (hotspotEntity.linkless) {
        return noop;
      }
      const hotspotTarget = hotspotEntity.target;
      const targetChapterId = hotspotTarget.chapterId;
      const targetType = hotspotTarget.type;
      const targetUrl = hotspotTarget.target;

      let slug;
      if (targetType === HotspotTargetType.CHAPTER) {
        const targetChapter = findChapterById(targetChapterId, story);
        slug = targetChapter.slugs[0];
        if (targetChapter.parent) {
          const parentChapter = findChapterById(targetChapter.parent, story);
          slug = `${parentChapter.slugs[0]}/${slug}`;
        }
      }
      if (targetType === HotspotTargetType.CHAPTER) {
        NavigationWrapper.push(null, storySlug, slug);
      } else if (targetType === HotspotTargetType.LINK) {
        window.open(targetUrl, "_blank").focus();
      } else if (targetType === HotspotTargetType.EXTERNAL_CALLBACK) {
        handleExternalCallbackHotspotClick(hotspotId);
      } else {
        return noop;
      }

      let target;
      if (targetType === HotspotTargetType.LINK) {
        target = targetUrl;
      } else if (targetType === HotspotTargetType.CHAPTER) {
        target = targetChapterId;
      } else if (targetType === HotspotTargetType.EXTERNAL_CALLBACK) {
        target = hotspotEntity.target.identifier;
      }

      hotspotClick({
        callbackIdentifier: hotspotEntity.target.identifier,
        duration: hotspotEntity.duration,
        hotspotType: hotspotEntity.hotspotType,
        originationChapterId: chapterEntity.id,
        startTime: hotspotEntity.startTime,
        target,
        targetType,
        time: playbackState.time,
      });
    },
  );
}
